import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this._schedule()
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  _schedule() {
    this._timeout = setTimeout(() => {
      this.element.src = window.location.href
      this._schedule()
    }, this.intervalValue)
  }
}
